import { EProblemReportStatus } from '@constants';
import { Tabs } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FiltersHandler } from './components/FiltersHandler';
import { ProblemReportsDrawer } from './components/ProblemReportsDrawer';
import { ProblemReportsTable } from './components/ProblemReportsTable';
import { HeaderWrapper, Subtitle, TitleWrapper } from './styles';

import { PagePaddingContainer } from '@/components/PagePaddingContainer';
import { PageTitle } from '@/components/PageTitle';
import { useProblemReportsList, useProfile } from '@/store';

const OPEN_STATUS_KEY = 'OPEN';
const REVIEWED_STATUS_KEY = 'REVIEWED';
const ALL_STATUS_KEY = 'ALL_STATUS';

const TAB_STATUS_MAP: Record<string, EProblemReportStatus[] | undefined> = {
  [OPEN_STATUS_KEY]: [EProblemReportStatus.NOT_REVIEWED, EProblemReportStatus.IN_REVIEW],
  [REVIEWED_STATUS_KEY]: [EProblemReportStatus.REVIEWED],
  [ALL_STATUS_KEY]: undefined
};

export const ProblemReportsPage = () => {
  const { t } = useTranslation('ProblemReportsTranslations');
  const [tabSelected, setTabSelected] = useState<string>(OPEN_STATUS_KEY);
  const { clearSort, setPageAndLimit } = useProblemReportsList();
  const {
    roleCheck: { isTeacher }
  } = useProfile();

  const tabStatus = TAB_STATUS_MAP[tabSelected];

  const handleTabChange = (tab: string) => {
    setPageAndLimit(1, 20);
    if (tabSelected === ALL_STATUS_KEY && tab !== ALL_STATUS_KEY) {
      clearSort();
    }
    setTabSelected(tab);
  };

  const items = [
    {
      label: t('OPEN_PROBLEM_REPORTS'),
      key: OPEN_STATUS_KEY,
      children: (
        <ProblemReportsTable
          tabStatus={TAB_STATUS_MAP[OPEN_STATUS_KEY]}
          emptyContent={{
            title: t('NO_OPEN_PROBLEM_REPORTS'),
            description: t('NO_OPEN_PROBLEM_REPORTS_DESCRIPTION'),
            emoji: '🎉'
          }}
        />
      )
    },
    {
      label: t(EProblemReportStatus.REVIEWED),
      key: REVIEWED_STATUS_KEY,
      children: (
        <ProblemReportsTable
          tabStatus={TAB_STATUS_MAP[REVIEWED_STATUS_KEY]}
          emptyContent={{
            title: t('NO_SOLVED_PROBLEM_REPORTS'),
            description: t('NO_SOLVED_PROBLEM_REPORTS_DESCRIPTION'),
            emoji: '🥺'
          }}
        />
      )
    },
    {
      label: t('ALL_STATUS'),
      key: ALL_STATUS_KEY,
      children: (
        <ProblemReportsTable
          emptyContent={{
            title: t('NO_PROBLEM_REPORTS'),
            description: t('NO_PROBLEM_REPORTS_DESCRIPTION'),
            emoji: '😌'
          }}
        />
      )
    }
  ];

  return (
    <PagePaddingContainer>
      <HeaderWrapper>
        <TitleWrapper>
          <PageTitle title={t('INCIDENTS')}></PageTitle>
          <Subtitle>
            {t(isTeacher ? 'INCIDENTS_DESCRIPTION_TEACHER' : 'INCIDENTS_DESCRIPTION')}
          </Subtitle>
        </TitleWrapper>
      </HeaderWrapper>
      <FiltersHandler tabStatus={tabStatus} />
      <Tabs id="problem-reports-tabs" items={items} onChange={handleTabChange} />
      <ProblemReportsDrawer />
    </PagePaddingContainer>
  );
};
